import React from 'react';
import { Routes, Route } from "react-router-dom";
import TransferList from "./transfer-list/transfer-list";

const Transfers = () => {
  return (
    <Routes>
      <Route index element={<TransferList />} />
    </Routes>
  )
}

export default Transfers;
